import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { ArcusAuthService } from "../../core/arcusauth.service";
import type { IArcusApplication, IArcusApplicationMenu } from "../../interfaces";
import DataService from "../services/data.service";
import ExceptionService from "../services/exception.service";
import { Subscription } from "rxjs";
import { MatButton, MatMiniFabButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { UserPreferenceService } from "../../SettingsV2/services/user-preference.service";

@Component({
    selector: "app-select",
    templateUrl: "./app-select.component.html",
    styleUrls: ["./app-select.component.scss"],
    imports: [MatButton, RouterLink, MatIcon, MatMiniFabButton, MatTooltip],
})
export class AppSelectComponent implements OnInit, OnDestroy {
    loaded: boolean = false;
    apps: IArcusApplication[] = [];
    menuItems: IArcusApplicationMenu[] = [];
    authSub: Subscription;
    constructor(
        private dataService: DataService,
        private exceptionService: ExceptionService,
        public router: Router,
        public authService: ArcusAuthService,
        private userPreferenceService: UserPreferenceService
    ) {}

    ngOnInit() {
        this.authSub = this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
            if (isAuthenticated) {
                Promise.all([this.getApplications(), this.getApplicationMenus()])
                    .then((results) => {
                        this.apps = results[0];
                        this.menuItems = results[1];

                        // TODO: Update 'ArcusApplications' in DB to exclude '~' and remove these two lines
                        this.apps.forEach((x) => (x.Url = x.Url.toLowerCase().replace("~", "")));
                        this.menuItems.forEach((x) => (x.Url = x.Url.toLowerCase().replace("~", "")));
                    })
                    .catch((error) => this.exceptionService.handleException(error))
                    .finally(() => {
                        this.loaded = true;
                    });
            }
        });
    }

    ngOnDestroy() {
        this.authSub.unsubscribe();
    }

    getApplications(): Promise<IArcusApplication[]> {
        return this.dataService.getApi<IArcusApplication[]>("ArcusApplication");
    }

    getApplicationMenus(): Promise<IArcusApplicationMenu[]> {
        return this.dataService.getApi<IArcusApplicationMenu[]>("ArcusApplicationMenu");
    }

    filteredMenuItems(appID: number) {
        return this.menuItems.filter((mi) => mi.ArcusApplicationID == appID && mi.ShowOnAppSelect == true);
    }

    isSettingsUrl(url: string): boolean {
        return url?.toLowerCase().includes("settings");
    }

    preloadSettingsPreferences() {
        this.userPreferenceService.refresh();
    }
}
